/*
 * @description:
 * @author: zzlei
 * @Date: 2020-11-26 23:11:28
 */
import request from '@/utils/request'
import { ADMIN_SERVICE_URL } from '@/utils/constant'
export function list(queryParams) {
  return request({
    url: `${ADMIN_SERVICE_URL}/simulateMember`,
    method: 'get',
    params: queryParams
  })
}

export function detail(id) {
  return request({
    url: `${ADMIN_SERVICE_URL}/simulateMember/` + id,
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/simulateMember`,
    method: 'post',
    data: data
  })
}

export function update(id, data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/simulateMember/` + id,
    method: 'put',
    data: data
  })
}

export function del(ids) {
  return request({
    url: `${ADMIN_SERVICE_URL}/simulateMember/` + ids,
    method: 'delete'
  })
}

export function patch(id, data) {
  return request({
    url: `${ADMIN_SERVICE_URL}/simulateMember/` + id,
    method: 'patch',
    data: data
  })
}

export function createVirtualUser(num,sex){
  return request({
    url: `${ADMIN_SERVICE_URL}/simulateMember/createVirtualUser?num=`+num+'&sex='+sex,
    method: 'post',
  })
}

export function syncVirtualUser(){
  return request({
    url: `${ADMIN_SERVICE_URL}/simulateMember/syncVirtualUser`,
    method: 'post',
  })
}
